import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { OperationModeData } from '../../../types/operation-mode-data';

export abstract class PackageModulesFormBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getOperationModes(): OperationModeData[];
}
